import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { bloopers } from "@/mocks/extras";

export default function Bloopers() {
  return (
    <section id="bloopers" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Behind The Scenes"
              title="幕后花絮：成片之外的制作故事"
              desc="一部电影的质感，往往在镜头之外就已经决定了大半。从原著改编到选角、取景与声音设计，这些工序共同塑造了它最终的面貌。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
            {bloopers.map((item, index) => (
              <Reveal key={item.id} delay={index * 70}>
                <div className="h-full flex gap-5 p-6 md:p-7 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className={`${item.icon} text-2xl`} />
                  </span>
                  <div>
                    <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 font-label text-xs">
                      {item.tag}
                    </span>
                    <h3 className="mt-2.5 font-heading text-lg md:text-xl font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}